module.exports = {"530822101":"联珠镇","530822102":"通关镇","530822103":"龙坝镇","530822104":"新安镇","530822105":"团田镇","530822106":"新抚镇","530822107":"景星镇","530822108":"鱼塘镇","530822109":"文武镇","530822110":"坝溜镇","530822111":"泗南江镇","530822112":"雅邑镇","530822203":"孟弄彝族乡","530822208":"龙潭乡","530822212":"那哈乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530822.json
// module id = 2733
// module chunks = 0